// Ícones da landing — SVG inline, traço arredondado (estilo da marca).
// Substituem os emojis (que davam cara "antiga" e variam por aparelho).
import React from 'react';

const base = { fill: 'none', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const IcEscudo = ({ cor = '#43a047', tam = 24 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <path {...base} stroke={cor} d="M12 3l7 3v5c0 4.5-3 8.2-7 9.5C8 19.2 5 15.5 5 11V6l7-3z" />
    <path {...base} stroke={cor} d="M9 11.5l2 2 4-4.5" />
  </svg>
);

export const IcCadeado = ({ cor = '#4FA3E3', tam = 24 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <rect {...base} stroke={cor} x="5" y="10.5" width="14" height="9.5" rx="2.5" />
    <path {...base} stroke={cor} d="M8 10.5V8a4 4 0 018 0v2.5" />
    <circle cx="12" cy="15.4" r="1.4" fill={cor} />
  </svg>
);

export const IcCoracaoCruz = ({ cor = '#F2549D', tam = 24 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <path {...base} stroke={cor} d="M12 20.5S4 15.5 4 9.8C4 7.1 6.1 5 8.6 5c1.4 0 2.6.6 3.4 1.7C12.8 5.6 14 5 15.4 5 17.9 5 20 7.1 20 9.8c0 5.7-8 10.7-8 10.7z" />
    <path {...base} stroke={cor} d="M12 8.8v5M9.7 11h4.6" />
  </svg>
);

export const IcFamilia = ({ cor = '#8B5CF6', tam = 24 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <circle {...base} stroke={cor} cx="8.2" cy="7.5" r="2.6" />
    <circle {...base} stroke={cor} cx="16" cy="9" r="2.1" />
    <path {...base} stroke={cor} d="M3.8 19.5c0-2.9 2-5 4.4-5s4.4 2.1 4.4 5M12.8 19.5c.2-2.4 1.5-4 3.2-4 1.8 0 3.1 1.7 3.3 4" />
  </svg>
);

export const IcCheck = ({ cor = '#43a047', tam = 20 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <circle cx="12" cy="12" r="10" fill={cor} opacity="0.14" />
    <path {...base} stroke={cor} d="M7.5 12.4l3 3 6-6.5" />
  </svg>
);

export const IcSeta = ({ cor = '#fff', tam = 20 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <path {...base} stroke={cor} d="M5 12h13M13 6.5L19 12l-6 5.5" />
  </svg>
);

export const IcJogo = ({ cor = '#4FA3E3', tam = 26 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <rect {...base} stroke={cor} x="3" y="7" width="18" height="11" rx="4.5" />
    <path {...base} stroke={cor} d="M8 11v3.5M6.2 12.8h3.6" />
    <circle cx="15.3" cy="11.6" r="1.15" fill={cor} />
    <circle cx="17.8" cy="13.9" r="1.15" fill={cor} />
  </svg>
);

export const IcVoz = ({ cor = '#F2795B', tam = 26 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <path {...base} stroke={cor} d="M4 10v4h3.5L12 18V6l-4.5 4H4z" fill={cor} opacity="0.9" />
    <path {...base} stroke={cor} d="M15.5 9.5a4 4 0 010 5M18 7.5a7.2 7.2 0 010 9" />
  </svg>
);

export const IcEstrela = ({ cor = '#F2C14E', tam = 26 }) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
    <path {...base} stroke={cor} fill={cor} opacity="0.9"
      d="M12 3.5l2.5 5.2 5.7.7-4.2 3.9 1.1 5.6-5.1-2.8-5.1 2.8 1.1-5.6-4.2-3.9 5.7-.7L12 3.5z" />
  </svg>
);
